import _SessionAttendance from './model';
import create from './create';

export const SessionAttendance = _SessionAttendance;

SessionAttendance.create = create;

export default SessionAttendance;



// WEBPACK FOOTER //
// ./data/SessionsAttendance/model/index.js